// removed by extract-text-webpack-plugin
module.exports = {"popupBox":"_3UPsnGzkf13_JdLd56dbGg","popupBoxInner":"mdKz-pLRjUNEWnfg-XDhU","preloaderWrap":"PLyy-b4-HQlWHzc3IzpGS","noUnrealLicense":"_3eXMSqjuPPd-q_x5IidjJp","button":"_3ZIf3bicIlYvCRi8XoxcwM","btnContainer":"_3GlEbnzyzPLNQzn0EDwmVi"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/MigrationBox.scss
// module id = 2939
// module chunks = 0